import React from "react";
import Card from "../common/Card/Card";
import Skeleton from "../common/Skeleton/Skeleton";
import SkeletonCircle from "./SkeletonCircle";

interface Props {
    className?: string;
}

const SkeletonDonut = ({ className }: Props) => (
    <Card padding="large" className={className}>
        <div className="flex flex-col gap-2">
            <div className="flex justify-between gap-1">
                <div className="space-y-1">
                    <Skeleton width="6rem" />
                    <Skeleton width="7rem" />
                </div>
                <div>
                    <SkeletonCircle width="5rem" height="5rem" />
                </div>
            </div>

            <div className="flex grow flex-wrap gap-1">
                <div className="space-y-1">
                    <Skeleton width="2rem" />
                    <Skeleton width="5rem" />
                </div>
                <div className="space-y-1">
                    <Skeleton width="2rem" />
                    <Skeleton width="5rem" />
                </div>
                <div className="space-y-1">
                    <Skeleton width="2rem" />
                    <Skeleton width="5rem" />
                </div>
            </div>
        </div>
    </Card>
);

export default SkeletonDonut;
